module.exports = __webpack_public_path__ + "c32fd19f8ac1b535e2fd97f64909c8c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/logged-out/login-diamond-pattern.png
// module id = 871
// module chunks = 0